import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import * as s from './Welcome.scss';
import Check from 'wix-ui-icons-common/Check';
import { learnMoreClicked, reportOpenEditTeamDetailsModal } from '../../redux/actions/bi.actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Heading, Text, Button, TextButton } from 'wix-style-react';

interface IAppProps extends InjectedTranslateProps {
  onStartClick(): void;
  learnMoreLink: string;
}

const Welcome: React.FC<IAppProps> = ({ t, onStartClick, learnMoreLink }) => {

  const dispatch = useDispatch();

  const onClickLearnMore = useCallback(() => {
    window.open(learnMoreLink, '_blank');
    dispatch(learnMoreClicked('/welcome'));
  }, [learnMoreLink, dispatch]);

  const onClickSetup = useCallback(() => {
    onStartClick();
    reportOpenEditTeamDetailsModal();
  }, [onStartClick]);

  return (
    <div>
      <div className={s.titleAnimation}>
        <Heading dataHook={'welcome-header'} appearance={'H1'}>
          {t('welcome.title')}
        </Heading>
        <Heading appearance={'H3'} className={s.subtitle}>
          {t('welcome.subtitle')}
        </Heading>
      </div>
      <WelcomeParagraph t={t} />
      <div className={s.buttons}>
        <span className={s.cta}>
          <Button
            size={'large'}
            dataHook={'welcome-start-button'}
            onClick={onClickSetup}
            fullWidth={true}
          >
            {t('welcome.setup-team')}
          </Button>
        </span>
        <span className={s.cta}>
          <TextButton
            size={'medium'}
            dataHook={'welcome-learn-more-button'}
            underline="onHover"
            onClick={onClickLearnMore}
          >
            {t('welcome.learn-more')}
          </TextButton>
        </span>
      </div>
    </div>
  );
};

export default translate(null)(Welcome);

function WelcomeParagraph({ t }) {
  return (
    <ul className={s.list}>
      <li>
        <Check className={s.listItem} /> <Text>{t('welcome.bullet-1')}</Text>
      </li>
      <li>
        <Check className={s.listItem} /> <Text>{t('welcome.bullet-2')}</Text>
      </li>
      <li>
        <Check className={s.listItem} /> <Text>{t('welcome.bullet-3')}</Text>
      </li>
    </ul>
  );
}
